import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% zniżki od {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Zaoszczędź {{percentageAmount}}% na wybranych produktach',
  [OfferKindEnum.AmountOffByProducts]: 'Zaoszczędź {{amount}} na wybranych produktach',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Zaoszczędź {{amount}} od {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 w cenie 1 – tylko dziś',
  [OfferKindEnum.BogoHalfPrice]: 'Kup jeden, drugi za pół ceny',
  [OfferKindEnum.FreeItemByProducts]: 'Dziś: odbierz swój gratis!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Dziś: odbierz gratis przy min. wartości zamówienia!',
};

export default OfferLabel;
